export default "__VITE_ASSET__JyEvgDzX__"